import { Component, Vue } from 'vue-property-decorator';
import { PropOptions } from 'vue';

const DashboardWidgetProps = Vue.extend({
  props: {
    title: String,
    padding: <PropOptions>{
      type: Number,
      default: 0
    },
    scrollable: Boolean
  }
});

@Component
export default class DashboardWidget extends DashboardWidgetProps {

}